import React from 'react';

import { Client } from '@netfront/gelada-react-shared';
import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import { Mutation } from 'react-apollo';

import ErrorModal from '../ErrorModal';
import MutationRequest from '../MutationRequest';

export const CREATE_ORG_INVITATION_REQUEST = gql`
  mutation createOrgInvite(
    $firstName: String
    $lastName: String
    $emailInvited: String!
    $organisationId: Int!
    $permission: EMemberPermission!
    # $position: String
    $message: String
  ) {
    invitation {
      organisationInvitation(
        invitation: {
          firstName: $firstName
          lastName: $lastName
          emailUserInvited: $emailInvited
          organisationId: $organisationId
          permission: $permission
          # tittle: $position
          customMessage: $message
        }
      ) {
        id
        tokenId
        __typename
      }
      __typename
    }
  }
`;

const createOrgInvitationRequest = ({
  firstName,
  lastName,
  emailInvited,
  organisationId,
  permission,
  position,
  message,
  onError,
  onSuccessResult,
}) => (
  <Mutation client={Client()} mutation={CREATE_ORG_INVITATION_REQUEST}>
    {(createOrgInvite, { loading, error, data }) => {
      const variables = {
        firstName,
        lastName,
        emailInvited,
        organisationId,
        permission,
        position,
        message,
      };

      if (error) {
        return <ErrorModal error={error} onError={onError} />;
      }
      if (data) {
        onSuccessResult(data.invitation.createOrgInvitation);
      }

      return (
        <MutationRequest
          isLoading={loading}
          mutation={createOrgInvite}
          variables={variables}
        />
      );
    }}
  </Mutation>
);

createOrgInvitationRequest.propTypes = {
  emailInvited: PropTypes.string.isRequired,
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  onError: PropTypes.func.isRequired,
  onSuccessResult: PropTypes.func.isRequired,
  organisationId: PropTypes.number.isRequired,
  permission: PropTypes.string.isRequired,
  message: PropTypes.string,
  position: PropTypes.string,
};

createOrgInvitationRequest.defaultProps = {
  message: '',
  position: '',
};

export default createOrgInvitationRequest;
